module.exports = __webpack_public_path__ + "img/ywbk26.a09bc449.jpg";